import React from 'react'
import PropTypes from 'prop-types'
import {ListItemPrimaryText as RmwcListItemPrimaryText} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerListItemPrimaryText = ({children, ...otherProps}) => <RmwcListItemPrimaryText {...otherProps}>{children}</RmwcListItemPrimaryText>

DrawerListItemPrimaryText.propTypes = {
  children: PropTypes.any
}

export {DrawerListItemPrimaryText}
